import { render, staticRenderFns } from "./LocationSection.vue?vue&type=template&id=cfe68376&"
import script from "./LocationSection.vue?vue&type=script&lang=js&"
export * from "./LocationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe68376')) {
      api.createRecord('cfe68376', component.options)
    } else {
      api.reload('cfe68376', component.options)
    }
    module.hot.accept("./LocationSection.vue?vue&type=template&id=cfe68376&", function () {
      api.rerender('cfe68376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/LocationSection.vue"
export default component.exports